<template>
  <v-container class="content-wrapper" fluid>
    <v-row v-if="patents.length === 0">
      You have no favorite Patents.
    </v-row>
    <v-row class="mb-10 justify-start">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="pa-3"
        v-for="(patent, index) in patents"
        :key="'patent-' + index"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            class="d-flex flex-column"
            elevation="3"
            style="border-radius: 24px; height: 100%; "
            :class="{ 'on-hover': hover }"
            @click="handleCardClick(patent.id, $event)"
          >
            <div style="position: relative; width: 100%; text-align: center; overflow: hidden;">
              <v-app-bar
                flat
                class="custom-app-bar"
                style="position: absolute; top: 0; left: 0; width: 100%; z-index: 1; background: transparent;"
              >
                <v-chip flat label small color="blue" class="white--text font-weight-bold">
                  Patent
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!patent.isFavorite && $store.getters.roles"
                  @click="addFavorite(patent)"
                  icon
                  raised
                  medium
                >
                  <v-icon>mdi-heart-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="patent.isFavorite && $store.getters.roles"
                  @click="removeFavorite(patent)"
                  icon
                  raised
                  medium
                  color="red"
                >
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
              </v-app-bar>
              <div style="display: flex; justify-content: center; width: 100%; overflow: hidden;">
                <v-img
                  v-if="patent.logo"
                  height="200px"
                  max-width="100%"
                  v-bind:src="patent.logo"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
                <v-img
                  v-else
                  height="200px"
                  max-width="100%"
                  lazy-src="@/assets/img/blur.jpg"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
              </div>
            </div>

            <v-card-text>
              <div class="text-start" align="start" justify="start">
                <v-col cols="12" class="black--text">
                  <b style="font-size: 20px;">{{ patent.title }}</b>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Services Organisation</label>
                  <div>
                    <router-link
                      :to="{
                        name: 'OverviewProvider',
                        params: { id: patent.organisation.id },
                        query: { patentFavoriteQuery: true },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.organisation.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Hosting Legal Entity</label>
                  <div>
                    <router-link
                      :to="{
                        name: 'OverviewHostingInstitution',
                        params: { id: patent.hostingInstitution.id },
                        query: { patentFavoriteQuery: true },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.hostingInstitution.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Tags</label>
                  <v-row class="mt-2" v-if="patent.tags.length > 0">
                    <v-chip
                      :color="color(index)"
                      v-for="(tag, index) in patent.tags"
                      :key="index"
                      class="ma-2"
                    >
                      {{ tag }}
                    </v-chip>
                  </v-row>
                </v-col>
              </div>
            </v-card-text>

            <v-spacer></v-spacer>
            <v-divider class="custom-divider"></v-divider>

            <v-card-actions>
              <v-row align="center">
                <v-col class="d-flex align-center">
                  <v-btn @click="redirectToOverview(patent.id)" icon style="min-width: auto;">
                    <v-icon style="color: rgba(0, 0, 0, 0.87)!important;" class="mr-2">
                      mdi-arrow-top-right
                    </v-icon>
                  </v-btn>
                  <p class="mb-0">More Details</p>
                </v-col>
                <v-col class="d-flex justify-end" v-if="patent.email != null">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click.stop=""
                        :href="'mailto:' + patent.email"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                          mdi-email-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Contact</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row v-if="pagesLength > 1">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ totalItems }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="options.itemsPerPage"
            :items="[10, 20, 30, 40, 50, 100]"
            dense
            outlined
            hide-details
            @change="onItemsPerPageChange"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
          @input="onPageChange"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'MyFavoritesPatents',
  mixins: [util],
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      patents: [],
      totalItems: 0,
      pagesLength: null,
      loading: false,
      patent: {
        title: '',
        logo: '',
        tags: [],
        organisation: {
          name: '',
          id: null,
        },
        isFavorite: false,
        email: '',
      },
      currentSortParams: '',
    };
  },
  props: {
    sortParams: {
      type: String,
    },
  },
  mounted() {
    this.currentSortParams = this.sortParams || '';
    this.getDataFromApi(this.currentSortParams);
  },
  watch: {
    sortParams: {
      deep: true,
      immediate: true,
      handler(newVal) {
        console.log('sortParams changed:', newVal);
        this.currentSortParams = newVal;
        this.getDataFromApi(newVal);
      },
    },
  },
  methods: {
    getDataFromApi(sortParams = this.currentSortParams) {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);

      const baseUrl = '/api/v1/favorites-patents';
      const params = this.getParams();

      const url = `${baseUrl}?index=${params.index}&size=${params.size}${
        sortParams ? `&${sortParams}` : ''
      }`;

      this.axios
        .get(url)
        .then(res => {
          if (res.status === 200) {
            console.log('Get Patents', res.data);
            this.patents = res.data.content;
            this.totalItems = res.data.total;
            this.pagesLength = res.data.pagesLength;
          }
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getDataFromApi(this.currentSortParams);
    },
    onPageChange(newPage) {
      this.options.page = newPage;
      this.getDataFromApi(this.currentSortParams);
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      return {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
      };
    },
    handleCardClick(patentId, event) {
      if (event.target.closest('a, button, .v-btn, .v-icon')) {
        return;
      }
      this.redirectToOverview(patentId);
    },
    redirectToOverview(patentId) {
      const favoritePatent = true;

      this.$router.push({
        name: 'OverviewPatent',
        params: { id: patentId },
        query: { favoritePatent },
      });
    },
    removeFavorite(patent) {
      const id = patent.id;
      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites-patents/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.getDataFromApi();
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding: 5px 0;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}
</style>
